export default [
    {
      path: '/order/viewLogistics',
      name: 'viewLogistics',
      meta: {
        index: 12
      },
      component: () => import('@/views/order/viewLogistics.vue')
    }
  ]